class FooterNewsletterForm extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector("form");
    this.emailInput = this.querySelector('input[name="contact[email]"]');
    this.consentCheckbox = this.querySelector("[data-newsletter-consent]");
    this.submitButton = this.querySelector('button[type="submit"]');

    if (!this.form || !this.emailInput || !this.consentCheckbox || !this.submitButton) {
      return;
    }

    this.emailInput.addEventListener("input", () => this.updateSubmitState());
    this.consentCheckbox.addEventListener("change", () => this.updateSubmitState());
    this.form.addEventListener("submit", (event) => {
      if (!this.isValid()) {
        event.preventDefault();
      }
    });

    this.updateSubmitState();
  }

  isValid() {
    return Boolean(this.emailInput.value.trim()) && this.emailInput.checkValidity() && this.consentCheckbox.checked;
  }

  updateSubmitState() {
    this.submitButton.disabled = !this.isValid();
  }
}

if (!window.customElements.get("footer-newsletter-form")) {
  window.customElements.define("footer-newsletter-form", FooterNewsletterForm);
}
